import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import "./CreatePattern.css";
import { PICS } from "./images";
import axios from "axios";
import { yarnTypes } from "./YarnTypes";

const CreateBook = () => {
  const [title, setTitle] = useState("");
  const [photo, setPhoto] = useState("");
  const [photoPath, setPhotoPath] = useState("");
  const [element, setElement] = useState("");
  const [yarnBrand, setYarnBrand] = useState("");
  const [colorCode, setColorCode] = useState("");
  const [patternElements, setPatternElements] = useState([]);
  const [addElement, setAddElement] = useState(false);
  const [submitReady, setSubmitReady] = useState(false);
  const [created, setCreated] = useState(false);

  const handlePhotoChange = (evt) => {
    setPhoto(evt.target.files[0]);
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    const pattern = {
      title,
      elements: patternElements,
      photoPath,
    };

    axios
      .post("/createPattern", { pattern })
      .then(setCreated(true))
      .catch((err) => console.log(err));
  };

  const handleElementSubmit = (evt) => {
    evt.preventDefault();
    const newElement = { element, yarnBrand, colorCode };
    setPatternElements([...patternElements, newElement]);
    setElement([]);
    setYarnBrand("");
    setColorCode("");
    setAddElement(false);
  };

  const deleteElement = (deleteItem) => {
    const newElements = patternElements.filter(
      (item) => item.element !== deleteItem
    );
    setPatternElements(newElements);
  };

  useEffect(() => {
    if (photo) {
      let url = "/fileUpload";
      const formData = new FormData();
      formData.append("file", photo);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      axios
        .post(url, formData, config)
        .then((response) => setPhotoPath(response.data.filePath));
    } else {
      return;
    }
  }, [photo]);

  let pageDisplay = "";
  if (!created) {
    pageDisplay = (
      <div className="formContainer">
        <h1 className="formHeading">Register a new pattern</h1>

        <form onSubmit={handleSubmit} className="form">
          <div className="elementsLabelInputContainer">
            <div className="labelInput">
              <label htmlFor="title" className="formLabel">
                Pattern Title
              </label>
              <input
                type="text"
                id="title"
                name="title"
                value={title}
                onChange={(evt) => setTitle(evt.target.value)}
                className="textInput"
                placeholder="Title"
              />
            </div>
          </div>
          <div className="uploadForm">
            <label htmlFor="photoUpload" className="uploadPhotoLabel">
              Select a photo to upload for this pattern
            </label>
            <input
              type="file"
              id="photoUpload"
              className="uploadFileInput"
              name="photo"
              onChange={handlePhotoChange}
            />
          </div>

          {!patternElements.length || addElement ? (
            <div className="elementsForm">
              <div className="elementsLabelInputContainer">
                <div className="elementsLabelInput">
                  <label htmlFor="element">Element</label>
                  <input
                    type="text"
                    value={element}
                    name="element"
                    onChange={(evt) => setElement(evt.target.value)}
                    className="elementInput"
                  />
                </div>
              </div>

              <div className="elementsLabelInputContainer">
                <div className="elementsLabelInput">
                  <select
                    onChange={(evt) => setYarnBrand(evt.target.value)}
                    className="brandDropdown"
                    name="brandDropdown"
                  >
                    <option
                      className="brandDropdownOption"
                      selected="true"
                      disabled={true}
                      default
                    >
                      Select Yarn brand...
                    </option>
                    {yarnTypes.map((brand) => (
                      <option className="brandDropdownOption" value={brand}>
                        {brand}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="elementsLabelInputContainer">
                <div className="elementsLabelInput">
                  <label htmlFor="colorCode">Color Code</label>
                  <input
                    type="text"
                    value={colorCode}
                    name="colorCode"
                    onChange={(evt) => setColorCode(evt.target.value)}
                    className="elementInput"
                  />
                </div>
              </div>
              <button
                className="addButton"
                type="submit"
                value="submit"
                onClick={handleElementSubmit}
              >
                Add Element
              </button>
            </div>
          ) : null}

          {patternElements.length && !addElement && !submitReady ? (
            <div className="addElementButtonsContainer">
              <p style={{ margin: "10px 0" }}>
                Do you want to add another element?
              </p>
              <div className="addElementButtons">
                <button
                  className="yesButton"
                  onClick={() => setAddElement(true)}
                >
                  Yes
                </button>
                <button
                  className="noButton"
                  onClick={() => setSubmitReady(true)}
                >
                  No
                </button>
              </div>
            </div>
          ) : null}
        </form>

        {patternElements.length ? (
          <div className="elementsList">
            <h4>Elements List</h4>
            <table className="elementsTable">
              <thead>
                <th>Element</th>
                <th>Yarn Brand</th>
                <th>Yarn Code</th>
                <th>Delete</th>
              </thead>
              <tbody>
                {patternElements.map((item) => {
                  return (
                    <tr className="tableRow">
                      <td>{item.element}</td>
                      <td>{item.yarnBrand}</td>
                      <td>{item.colorCode}</td>
                      <td>
                        <button
                          className="tableButton"
                          onClick={() => deleteElement(item.element)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : null}

        {submitReady && (
          <button className="submitButton" onClick={handleSubmit}>
            Submit Pattern
          </button>
        )}
      </div>
    );
  } else {
    alert("Pattern Created!");
    pageDisplay = <Navigate to="/" />;
  }

  return pageDisplay;
};

export default CreateBook;

// const handlePhotoUpload = (evt) => {
//   evt.preventDefault();
//   console.log("upload1");
//   let url = "/fileUpload";

//   const formData = new FormData();
//   formData.append("file", photo);
//   const config = {
//     headers: {
//       "content-type": "multipart/form-data",
//     },
//   };
//   axios
//     .post(url, formData, config)
//     .then((response) => setPhotoPath(response.data.filePath))
//     .then((response) => handleSVGUpload());
// };

// const handleSVGUpload = () => {
//   let url = "/fileUpload";
//   console.log("upload2");
//   const formData = new FormData();
//   formData.append("file", svg);
//   const config = {
//     headers: {
//       "content-type": "multipart/form-data",
//     },
//   };
//   axios
//     .post(url, formData, config)
//     .then((response) => setSVGPath(response.data.filePath))
//     .then((response) => handleSubmit());
// };
